<div class="du-mail-popup">
    <div class="d-flex align-items-center justify-content-between du-mail-popup-header-bg">
      <div class="du-mail-popup-header">Edit Template {{ templateName }}</div>
      <mat-icon class="du-mail-popUp-close" (click)="popUpClose()">close</mat-icon>
    </div>
  
    <div class="du-mail-popup-container">
      <div class="email-dialog">
        <form>
          <div class="email-fields mb-2">
            <!-- Template Name -->
            <div class="form-control d-flex justify-content-between align-items-center mb-2 to-field">
              <div class="d-flex align-items-center flex-wrap gap-2 from-to-items-width">
                <span class="text-muted">Name &nbsp;|&nbsp;</span>
                <input matInput type="text" [(ngModel)]="templateName" name="templateName" placeholder="Template Name" class="to-input" />
              </div>
            </div>
  
            <!-- Template Description -->
            <div style="position: relative;">
              <textarea class="template-desc" [(ngModel)]="templateDesc" name="templateDesc" placeholder="Template Description" (input)="onTemplateDesc($event)"></textarea>
            </div>
  
            <!-- Template Subject -->
            <div class="form-control d-flex justify-content-between align-items-center mb-2 to-field">
              <div class="d-flex align-items-center flex-wrap gap-2 from-to-items-width">
                <span class="text-muted">Subject &nbsp;|&nbsp;</span>
                <input matInput type="text" [(ngModel)]="templateSubject" name="templateSubject" placeholder="Template Subject" class="to-input" />
              </div>
            </div>
  
            <!-- Template Body -->
            <div style="position: relative;">
              <div #messageInput contenteditable="true" class="email-body" (input)="onMessageInput($event)"></div>
            </div>
          </div>
  
          <div class="toolbar">
            <div class="text-options bg-light text-primary">
              <button mat-icon-button type="button" (click)="formatText('bold')"><mat-icon>format_bold</mat-icon></button>
              <button mat-icon-button type="button" (click)="formatText('italic')"><mat-icon>format_italic</mat-icon></button>
              <button mat-icon-button type="button" (click)="formatText('underline')"><mat-icon>format_underlined</mat-icon></button>
  
              <button mat-icon-button type="button" (click)="fileInput.click()">
                <mat-icon>attach_file</mat-icon>
              </button>
  
              <!-- Hidden File Input -->
              <input #fileInput type="file" style="display: none;" (change)="onFileSelected($event)" multiple />
  
              <!-- ✅ Combined Attachments (Existing + Newly Uploaded) -->
              <div class="uploaded-files" *ngIf="combinedAttachments.length > 0">
                <div *ngFor="let file of combinedAttachments; let i = index" class="file-item">
                  <mat-icon>insert_drive_file</mat-icon>
                  <!-- Template Attachment -->
                  <ng-container *ngIf="file.isTemplateFile">
                    <a [href]="file.url" target="_blank">{{ file.name }}</a>
                  </ng-container>
                  <!-- Uploaded File -->
                  <ng-container *ngIf="!file.isTemplateFile">
                    {{ file.name }}
                    <button mat-icon-button (click)="removeUploadedFile(file.index)">
                      <mat-icon>close</mat-icon>
                    </button>
                  </ng-container>
                </div>
              </div>
  
            </div>
  
            <div class="actions">
              <button class="cancel" mat-flat-button color="secondary" type="button" (click)="cancel()">
                <span>Cancel</span>
              </button>
              <button class="submit" mat-flat-button color="primary" type="button" (click)="saveChanges()">
                <span>Save Changes</span>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  
  